/**************************************************
 * Nombre:       Home_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Tarjeta_Servicios from "../../Tarjetas/Tarjeta_Servicios";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";


const Home_Servicios = () => {
    const [servicios,setServicios] = useState([])

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'servicios', wheres: w}).then((dox) => {
            setServicios(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{color: theme.palette.primary.main, fontSize: 32, fontWeight: 800}}>Servicios</Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 1}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography
                                        sx={{
                                            color: '#000',
                                            fontSize: 16,
                                            fontWeight: 300,
                                            textAlign: 'center',
                                            lineHeight: 1.2
                                        }}>50 años en la
                                        isla nos hacen expertos en San Andrés. Contamos con Personal bilingüe altamente
                                        calificado en atención y servicio al cliente</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 1}}>
                                    <Typography
                                        sx={{
                                            color: '#000',
                                            fontSize: 16,
                                            fontWeight: 600,
                                            textAlign: 'center',
                                            lineHeight: 1.2
                                        }}>
                                        Tu itinerario acorde a tus necesidades y expectativas
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={6}
                            >


                                {servicios.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Servicios item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>



            </Grid>


        </Grid>
    )

}
export default Home_Servicios

